<div class="documentContent">
  <wk-input
    *ngIf="!compare"
    label="{{ 'APP.ACTIONS.COMPARE_AND_MERGE' | translate }}"
  >
    <input
      class="wk-field-input compare-field"
      autocomplete="off"
      type="text"
      readonly
    />
  </wk-input>

  <div *ngIf="compare">
    <wk-input label="{{ 'APP.ACTIONS.COMPARE_AND_MERGE' | translate }}">
      <input
        class="wk-field-input compare-field"
        autocomplete="off"
        type="text"
        readonly
        id="compare-document-below-test"
        [(ngModel)]="
          compare[0].number +
          ' ' +
          compare[0].name +
          ' ' +
          compare[0].checkedIn +
          ' ' +
          compare[0].createdBy
        "
      />
    </wk-input>

    <wk-tooltip
      type="description"
      position="bottom"
      target-selector="#compare-document-below-test"
      ><p slot="body">
        {{
          compare[0]?.number +
            ' ' +
            compare[0]?.name +
            ' ' +
            compare[0]?.checkedIn +
            ' ' +
            compare[0]?.createdBy
        }}
      </p></wk-tooltip
    >
  </div>

  <div
    class="swap"
    (click)="swap(compare, compareWith)"
    (keyup)="swap(compare, compareWith)"
  >
    <span
      title="swap-vertical"
      class="wk-icon-swap-vertical swapVertical"
    ></span>
  </div>

  <wk-input
    *ngIf="!compareWith"
    label="{{ 'APP.ACTIONS.WITH_LABEL' | translate }}"
  >
    <input
      class="wk-field-input with-field"
      autocomplete="off"
      type="text"
      readonly
    />
  </wk-input>

  <div *ngIf="compareWith">
    <wk-input label="{{ 'APP.ACTIONS.WITH_LABEL' | translate }}">
      <input
        class="wk-field-input with-field"
        autocomplete="off"
        type="text"
        readonly
        id="CompareWith-document-below-test"
        [(ngModel)]="
          compareWith[0].number +
          ' ' +
          compareWith[0].name +
          ' ' +
          compareWith[0].checkedIn +
          ' ' +
          compareWith[0].createdBy
        "
      />
    </wk-input>

    <wk-tooltip
      type="description"
      position="bottom"
      target-selector="#CompareWith-document-below-test"
      ><p slot="body">
        {{
          compareWith[0].number +
            ' ' +
            compareWith[0].name +
            ' ' +
            compareWith[0].checkedIn +
            ' ' +
            compareWith[0].createdBy
        }}
      </p></wk-tooltip
    >
  </div>

  <wk-content-node-selector-widget
    [parentFolderId]="parentId"
    [currentFileId]="id"
  >
  </wk-content-node-selector-widget>
</div>
